export class CookieKey {
    static language : string = 'LANGUAGE'
}